module.exports = __webpack_public_path__ + "static/media/medocs_01_thumb_hover.24cade18.png";